import * as React from "react"

const Tiktok = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M7.095 6.468V8.53a1.794 1.794 0 0 0-2.25 1.662 1.622 1.622 0 0 0 1.734 1.724 1.617 1.617 0 0 0 1.733-1.744V2h2.04c.347 2.157 1.425 2.658 2.87 2.889v2.067a6.142 6.142 0 0 1-2.813-.95v4.084C10.408 11.938 9.313 14 6.594 14a3.83 3.83 0 0 1-3.814-3.93 3.757 3.757 0 0 1 4.315-3.602Z" />
  </svg>
)

export default Tiktok
